module.exports = function getResource(label, vars = []) {
    let resources = {
        recommended: 'Recommended',
        reviews: 'Reviews',
        summary: 'Summary'
    };
    return resources[label];
};
